
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M9.023.008c-.742 0-1.405.377-1.824.834-.419.457-.674.976-.894 1.482-.44 1.012-.826 2.017-1.055 2.254-.023.024-.2.127-.576.182-.377.054-.893.065-1.444.101-.55.037-1.145.089-1.746.356-.6.267-1.192.867-1.375 1.644-.173.74.001 1.485.327 2.022.325.536.75.913 1.146 1.248.79.669 1.37 1.195 1.441 1.52.092.416-.16 1.346-.396 2.39-.118.522-.222 1.086-.14 1.707.08.621.419 1.302 1.015 1.752v.002a2.549 2.549 0 002.006.445c.618-.13 1.11-.42 1.558-.703.896-.566 1.669-1.039 1.957-1.039.289 0 1.062.473 1.957 1.04.448.282.94.573 1.56.702.618.13 1.399.012 2.005-.445V17.5a2.67 2.67 0 001.016-1.752c.08-.621-.023-1.185-.141-1.707-.236-1.044-.488-1.974-.397-2.39.072-.326.652-.851 1.442-1.52.395-.335.821-.712 1.146-1.248.325-.537.5-1.281.326-2.022-.182-.777-.774-1.377-1.375-1.644-.6-.267-1.195-.32-1.746-.356-.55-.036-1.066-.047-1.443-.101-.376-.055-.553-.158-.576-.182-.23-.237-.615-1.242-1.055-2.254-.22-.506-.475-1.025-.894-1.482-.42-.457-1.082-.834-1.825-.834z","clip-rule":"evenodd","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    